import React, { useContext, useEffect, useState } from 'react';
import { UpsellItems } from '../../components/upsell-items.jsx';
import { CartContext } from '../../context.jsx';
import { checkHasSubscription, filterByItemId, getItemsId } from './helpers';
import { SELECTORS } from './constants';

export const UpsellItemsContainer = () => {
  const { dataset: { variantIds }} = document.querySelector(`.${SELECTORS.UPSELL_VARIANT_DATA}`);

  if (!variantIds.length) {
    return null;
  }

  const { cart, addItem } = useContext(CartContext);
  const [items, setItems] = useState([]);

  const handleAddItem = (variantId) => {
    addItem({
      quantity: 1,
      variantId,
      isSubscription: false
    });
  };

  const buildItem = (variantId) => {
    const {
      productTitle,
      customTitle,
      flavor,
      variantTitle,
      image,
      price
    } = window.variantDataSelector.getData(variantId);

    return {
      variantId,
      productTitle: customTitle || productTitle,
      customTitle,
      flavor,
      variantTitle,
      image,
      finalPrice: price
    };
  };

  useEffect(() => {
    const shouldBeHidden = checkHasSubscription(cart.items);

    if (shouldBeHidden) {
      setItems([]);
    } else {
      const filterCartItems = filterByItemId(getItemsId(cart.items));
      const filteredItems = variantIds.split(',').map(buildItem).filter(filterCartItems);

      setItems(filteredItems);
    }
  }, [cart.items, variantIds]);

  return items.length > 0 ? (
    <UpsellItems items={items} onAddItem={handleAddItem} />
  ) : null;
};
